export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.47 4.47a.75.75 0 01.809-.166l15 6a.75.75 0 01-.073 1.417l-6.6 1.886-1.885 6.6a.75.75 0 01-1.417.072l-6-15a.75.75 0 01.166-.81zm1.876 1.876l4.536 11.338 1.397-4.89a.75.75 0 01.515-.515l4.89-1.397L6.347 6.346z\" fill=\"#6F7488\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};